import styled from 'styled-components';

import { Text } from '../../../../../components';
import { ThemeProp } from '../../../../../theme/Themes';

export const VehiclesCountContainer = styled(Text)`
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  font-size: ${(props: ThemeProp) => props.theme.fontVariants.desktop.body2.fontSize};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.m};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c900};
  min-width: 4.5rem;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    padding: 0 1rem;
  }
`;
